import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  where,
} from "firebase/firestore";

const normalizeRole = (value) => (value || "").toString().trim().toLowerCase();

export async function resolveUserRole(db, uid) {
  if (!uid) {
    return { role: null, profile: null };
  }

  // Primary admin lookup by doc id (existing login flow already relies on this).
  const adminDoc = await getDoc(doc(db, "admin", uid));
  if (adminDoc.exists()) {
    const data = adminDoc.data();
    const role = normalizeRole(data.userType || "admin");
    if (role === "admin") {
      return { role: "admin", profile: { id: adminDoc.id, ...data } };
    }
  }

  // Fallback admin lookup in case docs are keyed differently.
  const adminQuery = query(
    collection(db, "admin"),
    where("userId", "==", uid),
    limit(1)
  );
  const adminSnap = await getDocs(adminQuery);
  if (!adminSnap.empty) {
    const adminRecord = adminSnap.docs[0];
    const data = adminRecord.data();
    const role = normalizeRole(data.userType || "admin");
    if (role === "admin") {
      return { role: "admin", profile: { id: adminRecord.id, ...data } };
    }
  }

  // Customer/client accounts.
  const clientQuery = query(
    collection(db, "clients"),
    where("uid", "==", uid),
    limit(1)
  );
  const clientSnap = await getDocs(clientQuery);
  if (!clientSnap.empty) {
    const clientRecord = clientSnap.docs[0];
    return {
      role: "client",
      profile: { id: clientRecord.id, ...clientRecord.data() },
    };
  }

  return { role: null, profile: null };
}
